import { FloatingDropdownProps } from './types';

export function getFloatingDropdownTestProps(
  overrides: Partial<FloatingDropdownProps> = {},
): FloatingDropdownProps {
  return {
    options: [
      { id: '1', value: 'Most recent', isSelectable: true },
      {
        id: '2',
        value: 'Disabled option',
        isSelectable: false,
      },
      { id: '3', value: 'Most liked', isSelectable: true },
      { divider: true },
      { id: '4', value: 'Most comments', isSelectable: true },
      {
        id: '5',
        value: 'Most recent posts in the whole galaxy',
        isSelectable: true,
      },
      { id: '6', value: 'Most viewed', isSelectable: true },
    ],
    label: 'Sort by:',
    placeholder: 'Most recent',
    optionsContainerId: 'the-best-id-ever',
    'aria-label': 'Sort by',
    ...overrides,
  };
}
